"use strict";
/**
 * What the flow modules share to check input and refuse a request. Free of
 * Node modules: the App definition checks its flow plan with it, in the
 * browser as well.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.text = exports.fail = exports.isRefusal = exports.refused = void 0;
exports.object = object;
/**
 * An error the StreamKit answers with `status` and its words. `text` names the
 * translation the bar shows; the message keeps the platform's words for API
 * callers. `more` adds fields the caller reads off the error.
 */
const refused = (status, message, text, more = {}) => Object.assign(new Error(message), {
    status,
    ...(text ? { text } : {}),
    ...more,
});
exports.refused = refused;
/** Whether `error` is one that answers with a `status`, whoever made it. */
const isRefusal = (error) => error instanceof Error &&
    'status' in error &&
    typeof error.status === 'number';
exports.isRefusal = isRefusal;
/** Refuses a plan; every message names the StreamKit flows. */
const fail = message => {
    throw new Error(`StreamKit flows: ${message}`);
};
exports.fail = fail;
/** A non-empty string of at most `max` characters. */
const text = (value, max = 240) => typeof value === 'string' && value.length > 0 && value.length <= max;
exports.text = text;
/** An object whose fields are all among `fields`. */
function object(value, fields, label) {
    if (!value ||
        typeof value !== 'object' ||
        Array.isArray(value) ||
        Object.keys(value).some(key => !fields.includes(key)))
        (0, exports.fail)(`invalid ${label}`);
}
